export default __webpack_public_path__ + "static/media/template_retrospective.322302be.png";